import React, { Component } from 'react';
import '../App.css';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {isLoggedIn, ifMagazyn} from '../utils/AuthService';

var ListwyDoZam = React.createClass({

getInitialState: function() {

  return {
    addObject: {
      id: '',
      idZlecenie: '',
      numerListwy: '',
      iloscCm: ''
    },
    data: null,
    selectedListwaId: null
  }
  },

  onRowSelect: function(row, isSelected) {

		if(isSelected) {
			this.setState({ selectedListwaId: row.id });
		}else {
			this.setState({ selectedListwaId: null });
		}
	},

  onDeleteBtnClicked: function() {

    axios.delete('http://217.182.200.222:8080/listwyDoZam/' + this.state.selectedListwaId)
      .then(function (response) {
        this.refreshTable();
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },

  refreshTable: function() {
    axios.get('http://217.182.200.222:8080/listwyDoZam')
    .then(function (dictListwy) {
      this.setState({data: dictListwy.data});
    }.bind(this));
  },

  getListwyById: function(id) {
    for(var i in this.state.data) {
      if(this.state.data[i].id === id) {
        return this.state.data[i];
      }
    }
    return '';
  },

  render: function() {
    var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

    if(!isLoggedIn()){
			return (<div></div>);
		};


  return (
    <div>
	<div className="form-group">

  <div className="row">
    <div className="col-sm-4">
      <div className="row">
        <div className="col-sm-4">
            <label htmlFor="numerZlecenia">Numer zlecenia: </label>
        </div>
        <div className="col-sm-8">
          <FormControl
            type="text"
            placeholder="Numer zlecenia"
            value={this.state.addObject.idZlecenie}
            onChange={this.onAddNumerZlecenieChange} />
        </div>
      </div>
    </div>
    <div className="col-sm-8">
    </div>
  </div>

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="numerListwy">Numer Listwy: </label>
					</div>
					<div className="col-sm-8">
            <FormControl
              type="text"
              placeholder="Numer Listwy"
              value={this.state.addObject.numerListwy}
              onChange={this.onAddNumerChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8">
      </div>
		</div>

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="cenaZaMb">Ilość cm: </label>
					</div>
					<div className="col-sm-8">
          <FormControl
            type="text"
            placeholder="Ilość cm"
            value={this.state.addObject.iloscCm}
            onChange={this.onAddIloscCmChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8"/>
		</div>

	</div>

  <div>
  <Button bsStyle="primary" disabled={ifMagazyn()} onClick={this.onAddBtnClicked}>Dodaj Listwę</Button>
  </div>
    <br/>
  <BootstrapTable data={this.state.data}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          selectRow={selectRowProp}>
    <TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="idZlecenie" dataSort={true}>Numer zlecenia</TableHeaderColumn>
    <TableHeaderColumn dataField="numerListwy" dataSort={true}>Numer Listwy</TableHeaderColumn>
    <TableHeaderColumn dataField="iloscCm">Ilość cm</TableHeaderColumn>
  </BootstrapTable>

<br/>
<div>
<Button bsStyle="danger" disabled={ifMagazyn()} onClick={this.onDeleteBtnClicked}>Usuń Listwę</Button>
</div>

</div>
  );
},

componentDidMount: function() {
  this.refreshTable();
},

clearAddObject: function() {
  this.state.addObject.id = null;
  this.state.addObject.numerListwy = '';
  this.state.addObject.idZlecenie = '';
  this.state.addObject.iloscCm = '';
},

onAddNumerZlecenieChange: function(event) {
  this.state.addObject.idZlecenie = event.target.value;
  this.forceUpdate();
},

onAddNumerChange: function(event) {
  this.state.addObject.numerListwy = event.target.value;
  this.forceUpdate();
},

onAddIloscCmChange: function(event) {
  this.state.addObject.iloscCm = event.target.value.replace(/,/g, '.');
  this.forceUpdate();
},

onAddBtnClicked: function() {
  axios.post('http://217.182.200.222:8080/listwyDoZam/', this.state.addObject)
    .then(function (response) {
      this.refreshTable();
    }.bind(this))
    .catch(function (error) {
      alert("Błędnie wprowadzone dane");
      console.log(error);
    });

    this.setState({
      addObject: {
        id: '',
        idZlecenie: '',
        numerListwy: '',
        iloscCm: ''
      }
    });
}
});

export default ListwyDoZam;



// WEBPACK FOOTER //
// ./src/components/ListwyDoZam.js